import React, { ReactNode } from 'react';
import './LinkStyledButton.css';

interface Props {
  children: ReactNode;
  onClick?: () => void;
}

const LinkStyledButton: React.FC<Props> = props => {
  return (
    <button className="link-styled-button" onClick={props.onClick} role="link" aria-label="click here">
      {props.children}
    </button>
  );
};

export default LinkStyledButton;
